/**
 * Notification Alert Plugin
 *
 * @returns $notification
 */

import type { NotificationParams } from 'element-plus';

import IconCritical from '@/components/Icon/Critical.vue';
import IconSuccess from '@/components/Icon/Success.vue';
import IconWarning from '@/components/Icon/Warning.vue';

export default defineNuxtPlugin(() => {
  const notification = (options: NotificationParams): void => {
    if (import.meta.client) {
      const type = (options as { type: string })?.type;

      const typeClass = (() => {
        switch (type) {
          case 'success':
            return 'is-success';
          case 'warning':
            return 'is-warning';
          case 'error':
            return 'is-error';
          case 'info':
            return 'is-info';
          default:
            return '';
        }
      })();

      const typeIcon = (() => {
        switch (type) {
          case 'success':
            return IconSuccess;
          case 'warning':
            return IconWarning;
          case 'error':
            return IconCritical;
          case 'info':
            return IconCritical;
          default:
            return undefined;
        }
      })();

      Object.assign(options, {
        type: '',
        icon: typeIcon,
        customClass: `element_el-notification ${typeClass}`,
        showClose: type !== 'success',
        duration: type === 'success' ? 4500 : 0,
      });

      ElNotification(options);
    }
  };
  return {
    provide: { notification },
  };
});
